module.exports = __webpack_public_path__ + "img/pic@2x (1).4fc4001a.png";